import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useUser, useAuth, useClerk } from '@clerk/clerk-react';

function DropDetail() {
  const { slug } = useParams();
  const { user } = useUser();

  const [drop, setDrop] = useState(null);
  const [loadingDrop, setLoadingDrop] = useState(true);
  const [dropError, setDropError] = useState(null);

  const [buying, setBuying] = useState(false);
  const [buyError, setBuyError] = useState(null);

  const { isSignedIn } = useAuth();
  const { openSignIn } = useClerk();

  useEffect(() => {
    async function fetchDrop() {
      setLoadingDrop(true);
      setDropError(null);
      try {
        const res = await fetch(`${process.env.REACT_APP_WORKER_URL}/catalog/${slug}`);
        if (!res.ok) {
          const text = await res.text();
          throw new Error(text || `Failed to load drop (${res.status})`);
        }
        const data = await res.json();
        setDrop(data);
      } catch (err) {
        setDropError(err.message);
      } finally {
        setLoadingDrop(false);
      }
    }
    fetchDrop();
  }, [slug]);

  async function handleBuy() {
    if (!isSignedIn) {
      openSignIn({ redirectUrl: window.location.href });
      return;
    }

    setBuying(true);
    setBuyError(null);
    try {
      const res = await fetch(`${process.env.REACT_APP_WORKER_URL}/create-checkout-session`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          dropSlug: drop.slug,
          dropName: drop.name,
          unitCount: drop.unitCount,
          dropPrice: drop.dropPrice,
          catalogId: drop.catalogId,
          clerkUserId: user?.id ?? 'test-user',
          stripeCustomerId: '',
          creditApplied: 0,
        }),
      });

      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || `Request failed with status ${res.status}`);
      }

      const { url } = await res.json();
      window.location.href = url;
    } catch (err) {
      setBuyError(err.message);
      setBuying(false);
    }
  }

  if (loadingDrop) return <main><p>Loading drop…</p></main>;
  if (dropError) return <main><p style={{ color: 'red' }}>Error: {dropError}</p></main>;
  if (!drop) return <main><p>Drop not found.</p></main>;

  return (
    <main>
      <h1>{drop.name}</h1>
      {drop.tagline && <p><em>{drop.tagline}</em></p>}
      {drop.description && <p>{drop.description}</p>}
      <p>Units available: {drop.unitCount}</p>
      <p>Price: ${drop.dropPrice?.toLocaleString()}</p>
      <p>Status: {drop.status}</p>

      {drop.status === 'Sold Out' && (
        <p style={{ color: '#888', fontSize: '14px', fontStyle: 'italic' }}>
          This drop is sold out. Check back for future drops.
        </p>
      )}
      {drop.status === 'Coming Soon' && (
        <p style={{ color: '#888', fontSize: '14px', fontStyle: 'italic' }}>
          This drop isn't available yet. Check back soon.
        </p>
      )}
      {drop.status === 'Active' && (
        <>
          <button onClick={handleBuy} disabled={buying}>
            {buying ? 'Redirecting to checkout…' : 'Buy This Drop'}
          </button>
          {buyError && <p style={{ color: 'red' }}>{buyError}</p>}
        </>
      )}
    </main>
  );
}

export default DropDetail;